import {ThemeProvider} from "@mui/material";
// import { LicenseInfo } from "@mui/x-license";
import {useEffect} from "react";
import {Navigate, Route, BrowserRouter as Router, Routes} from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import MainLayout from "./layouts/MainLayout";
import Acceso from "./pages/Acceso/Acceso";
import Dashboard from "./pages/Dashboard";
import RoleDetail from "./pages/RoleDetail";
import Roles from "./pages/Roles";
import ScopeDetail from "./pages/ScopeDetail";
import Scopes from "./pages/Scopes";
import UserDetail from "./pages/UserDetail";
import Users from "./pages/Users";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import {useAuthStore} from "./stores/useAuthStore";
import theme from "./styles/theme";
import Tokens from "./pages/Tokens";
import M2MTokens from "./pages/M2MTokens";

function App() {
  // Comentamos la configuración de licencia para usar la versión community
  // const LICENSE_KEY = process.env.REACT_APP_DATAGRID_PRO_LICENSE_KEY;
  // LicenseInfo.setLicenseKey(LICENSE_KEY);

  const {isAuthenticated, token, refreshAccessToken, isTokenExpired} = useAuthStore();

  // Verificar y refrescar token al cargar la aplicación
  useEffect(() => {
    const initializeAuth = async () => {
      if (token && isTokenExpired()) {
        await refreshAccessToken();
      }
    };

    initializeAuth();
  }, [token, isTokenExpired, refreshAccessToken]);

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          {/* Ruta de acceso sin layout cuando no está autenticado */}
          {!isAuthenticated && <Route path="/acceso" element={<Acceso />} />}

          <Route path="/" element={<MainLayout />}>
            {/* Rutas condicionadas por autenticación */}
            {isAuthenticated ? (
              <>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="login" element={<Navigate to="/dashboard" replace />} />
                <Route path="acceso" element={<Navigate to="/dashboard" replace />} />

                {/* Rutas protegidas */}
                <Route
                  path="dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="users"
                  element={
                    <ProtectedRoute>
                      <Users />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="roles"
                  element={
                    <ProtectedRoute>
                      <Roles />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="role-form"
                  element={
                    <ProtectedRoute>
                      <RoleDetail />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="user-form"
                  element={
                    <ProtectedRoute>
                      <UserDetail />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="scope-form"
                  element={
                    <ProtectedRoute>
                      <ScopeDetail />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="scopes"
                  element={
                    <ProtectedRoute>
                      <Scopes />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/clients"
                  element={
                    <ProtectedRoute>
                      <Clients />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="client-form"
                  element={
                    <ProtectedRoute>
                      <ClientDetail />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/tokens"
                  element={
                    <ProtectedRoute>
                      <Tokens />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/m2m-tokens"
                  element={
                    <ProtectedRoute>
                      <M2MTokens />
                    </ProtectedRoute>
                  }
                />

                {/* Fallback para rutas no encontradas cuando está autenticado */}
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </>
            ) : (
              <>
                {/* Rutas cuando no está autenticado */}
                <Route index element={<Navigate to="/acceso" replace />} />
                <Route path="login" element={<Navigate to="/acceso" replace />} />
                <Route path="dashboard" element={<Navigate to="/acceso" replace />} />
                <Route path="users" element={<Navigate to="/acceso" replace />} />
                <Route path="roles" element={<Navigate to="/acceso" replace />} />
                <Route path="role-form" element={<Navigate to="/acceso" replace />} />
                <Route path="user-form" element={<Navigate to="/acceso" replace />} />
                <Route path="*" element={<Navigate to="/acceso" replace />} />
              </>
            )}
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
